import Loadable from "@loadable/component";

const DynamicPage = Loadable(
  () => import(/* webpackChunkName: "dynamic_page" */ "./dynamicPage")
);

export default DynamicPage;
